import {
  PARTNER_SETTINGS_CHANGE_VALUE,
  PARTNER_SETTINGS_CHANGE_VALUES,
} from '@shared/store/constants/mutationTypes';
import apiClient from '@shared/lib/general/apiClient';

const actions = {
  changePartnerSettingsValue({ commit }, payload) {
    const {
      field,
      value,
    } = payload;
    commit({
      type: PARTNER_SETTINGS_CHANGE_VALUE,
      field,
      value,
    });
  },
  async getPartnerContacts({ commit }, payload) {
    const {
      corpId,
    } = payload;

    const { data } = await apiClient({
      method: 'GET',
      url: `/contacts/corp/${corpId}`,
    });

    actions.changePartnerSettingsValues({ commit }, [{
      field: 'contacts',
      value: data,
    }]);
  },
  async editPartnerContact({ commit, state }, payload) {
    const { data } = await apiClient({
      method: 'PUT',
      url: '/contacts/update',
      data: payload,
    });
    const { contacts } = state;
    actions.changePartnerSettingsValues({ commit }, [{
      field: 'contacts',
      value: [...contacts.filter((x) => x.id !== payload.id), data],
    }]);
  },
  async deletePartnerContact({ commit, state }, payload) {
    const { data } = await apiClient({
      method: 'DELETE',
      url: `/contacts/delete/${payload}`,
    });

    const { contacts } = state;
    actions.changePartnerSettingsValues({ commit }, [{
      field: 'contacts',
      value: [...contacts.filter((x) => x.id !== payload)],
    }]);
  },
  async createPartnerContact({ commit, state }, payload) {
    const { data } = await apiClient({
      method: 'POST',
      url: '/contacts/new',
      data: payload,
    });
    const { contacts } = state;
    actions.changePartnerSettingsValues({ commit }, [{
      field: 'contacts',
      value: [...contacts, data],
    }]);
  },
  changePartnerSettingsValues({ commit }, payload) {
    commit({
      type: PARTNER_SETTINGS_CHANGE_VALUES,
      changes: payload,
    });
  },
};
export default actions;
